import { action, createRequestTypes } from "../../actions";

export const LOAD_USER_DETAILS = createRequestTypes("LOAD_USER_DETAILS");
export const LOAD_USERS = createRequestTypes("LOAD_USERS");
export const LOAD_USERSV2 = createRequestTypes("LOAD_USERSV2");
export const LOAD_STUDENTS = createRequestTypes("LOAD_STUDENTS");
export const LOAD_THERAPISTS = createRequestTypes("LOAD_THERAPISTS");
export const SELECT_USER = createRequestTypes("SELECT_USER");
export const SELECT_THERAPIST = createRequestTypes("SELECT_THERAPIST");
export const SELECT_STUDENT = createRequestTypes("SELECT_STUDENT");
export const UPDATE_STUDENT = createRequestTypes("UPDATE_STUDENT");
export const UPDATE_STUDENT_LANGUAGE = createRequestTypes("UPDATE_STUDENT_LANGUAGE");
export const LOAD_STUDENT_AGREEMENTS = createRequestTypes("LOAD_STUDENT_AGREEMENTS");
export const SAVE_STUDENT_AGREEMENTS = createRequestTypes("SAVE_STUDENT_AGREEMENTS");
export const UPLOAD_STUDENT_FILES = createRequestTypes("UPLOAD_STUDENT_FILES");
export const LOAD_STUDENT_FILES = createRequestTypes("LOAD_STUDENT_FILES");
export const LOAD_STUDENT_FILE = createRequestTypes("LOAD_STUDENT_FILE");
export const DELETE_STUDENT_FILE = createRequestTypes("DELETE_STUDENT_FILE");

export const loadUser = {
  request: userId => action(LOAD_USER_DETAILS.REQUEST, { userId }),
  success: response => action(LOAD_USER_DETAILS.SUCCESS, { response }),
  failure: error => action(LOAD_USER_DETAILS.FAILURE, { error }),
};

export const loadUsers = {
  request: (userId) => action(LOAD_USERS.REQUEST, { userId }),
  success: response => action(LOAD_USERS.SUCCESS, { response }),
  failure: error => action(LOAD_USERS.FAILURE, { error }),
};

export const loadUsersV2 = {
  request: (filters, isEdited = false) => action(LOAD_USERSV2.REQUEST, { filters, isEdited }),
  success: response => action(LOAD_USERSV2.SUCCESS, { response }),
  failure: error => action(LOAD_USERSV2.FAILURE, { error }),
};

export const loadStudents = {
  request: (clinicId, therapistId) => action(LOAD_STUDENTS.REQUEST, { clinicId, therapistId }),
  success: response => action(LOAD_STUDENTS.SUCCESS, { response, reset: true, resetKey: "students" }),
  failure: error => action(LOAD_STUDENTS.FAILURE, { error }),
};

export const loadStudentAgreements = {
  request: () => action(LOAD_STUDENT_AGREEMENTS.REQUEST),
  success: response => action(LOAD_STUDENT_AGREEMENTS.SUCCESS, { response }),
  failure: error => action(LOAD_STUDENT_AGREEMENTS.FAILURE, { error }),
};

export const saveStudentAgreements = {
  request: (agreements, lang, notMandatoryAgree) => action(SAVE_STUDENT_AGREEMENTS.REQUEST, { agreements, lang, notMandatoryAgree }),
  success: response => action(SAVE_STUDENT_AGREEMENTS.SUCCESS, { response }),
  failure: error => action(SAVE_STUDENT_AGREEMENTS.FAILURE, { error }),
};

export const selectUser = user => action(SELECT_USER, { user });

export const selectTherapist = therapist => action(SELECT_THERAPIST, { therapist });

export const selectStudent = student => action(SELECT_STUDENT, { student });

export const updateStudent = {
  request: (studentId, student) => action(UPDATE_STUDENT.REQUEST, { studentId, student }),
  success: response => action(UPDATE_STUDENT.SUCCESS, { response }),
  failure: error => action(UPDATE_STUDENT.FAILURE, error),
};

export const updateStudentLanguage = {
  request: (languageId) => action(UPDATE_STUDENT_LANGUAGE.REQUEST, { languageId }),
  success: response => action(UPDATE_STUDENT_LANGUAGE.SUCCESS, { response }),
  failure: error => action(UPDATE_STUDENT_LANGUAGE.FAILURE, error),
};

export const loadStudentFiles = {
  request: studentId => action(LOAD_STUDENT_FILES.REQUEST, { studentId }),
  success: response => action(LOAD_STUDENT_FILES.SUCCESS, { response }),
  failure: error => action(LOAD_STUDENT_FILES.FAILURE, { error }),
};

export const uploadStudentFiles = {
  request: (studentId, files) => action(UPLOAD_STUDENT_FILES.REQUEST, { studentId, files }),
  success: response => action(UPLOAD_STUDENT_FILES.SUCCESS, { response }),
  failure: error => action(UPLOAD_STUDENT_FILES.FAILURE, { error }),
};

export const loadStudentFile = {
  request: (studentId, fileName) => action(LOAD_STUDENT_FILE.REQUEST, { studentId, fileName }),
  success: response => action(LOAD_STUDENT_FILE.SUCCESS, { response }),
  failure: error => action(LOAD_STUDENT_FILE.FAILURE, { error }),
};

export const deleteStudentFile = {
  request: (studentId, fileName) => action(DELETE_STUDENT_FILE.REQUEST, { studentId, fileName }),
  success: response => action(DELETE_STUDENT_FILE.SUCCESS, { response }),
  failure: error => action(DELETE_STUDENT_FILE.FAILURE, { error }),
};
